import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../styles/Success.css';

export default function Success() {
  const [confirmed, setConfirmed] = useState(false);
  const [error, setError] = useState(null);

  /* eslint-disable no-console */
  console.log(error);

  useEffect(() => {
    async function confirmPayment() {
      try {
        // Get session_id from URL query params
        const urlParams = new URLSearchParams(window.location.search);
        const sessionId = urlParams.get('session_id');

        if (sessionId) {
          // Call API to confirm payment and trigger email/message
          const response = await axios.get('/api/invoices/payment-success', {
            params: { session_id: sessionId },
            withCredentials: true,
          });

          if (response.data.success) {
            setConfirmed(true);
            /* eslint-disable no-console */
            console.log('Payment confirmed:', response.data);
          }
        } else {
          /* eslint-disable no-console */
          console.log('No session_id found in URL');
        }
      } catch (err) {
        /* eslint-disable no-console */
        console.error('Error confirming payment:', err);
        setError(
          err.response?.data?.error ||
            err.message ||
            'Failed to confirm payment',
        );
        // Don't show error to user, just log it - payment might already be confirmed
      }
    }

    confirmPayment();
  }, []);

  return (
    <div className="success-container">
      <div className="success-card">
        <div className="success-icon">
          <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
            <circle cx="32" cy="32" r="32" fill="#4CAF50" />
            <path
              d="M20 32L28 40L44 24"
              stroke="white"
              strokeWidth="4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        <h1 className="success-title">Payment Successful</h1>
        <p className="success-message">
          Thank you for your payment. Your transaction was successful.
        </p>

        <div className="success-note">
          <p>
            You will receive a confirmation email shortly with all the details
            of your booking.
          </p>
          {confirmed && (
            <p
              style={{
                marginTop: '10px',
                color: '#4CAF50',
                fontWeight: 'bold',
              }}
            >
              ✓ Payment confirmed and host notified
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
Success.propTypes = {};
